
import { PropType, toRefs, computed } from 'vue'
import { DiscountScopes } from '@invivodf/module-discount-sdk'
import { labeledScopes } from '@invivodf/common/src/contexts/discount/application/composables/labeledScopes'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'

export default {
  name: 'CDiscountScope',
  props: {
    scope: { type: String as PropType<DiscountScopes>, required: true },
  },
  setup(props) {
    const i18n = useI18nForVue2()

    const { scope } = toRefs(props)

    return {
      currentScopeText: computed(() => {
        const scopeText = labeledScopes.find((s) => s.value === scope.value)?.text
        return scopeText ? i18n.t(scopeText).toString() : ''
      }),
    }
  },
}
